module.exports = __webpack_public_path__ + "img/success.d7bf7758.png";